import { render, staticRenderFns } from "./Companyprofile.vue?vue&type=template&id=2f8633e6&scoped=true&"
import script from "./Companyprofile.vue?vue&type=script&lang=js&"
export * from "./Companyprofile.vue?vue&type=script&lang=js&"
import style0 from "./Companyprofile.vue?vue&type=style&index=0&id=2f8633e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8633e6",
  null
  
)

export default component.exports